import { render, staticRenderFns } from "./ProfileVisibilitySection.vue?vue&type=template&id=05790d6a&scoped=true&"
import script from "./ProfileVisibilitySection.vue?vue&type=script&lang=js&"
export * from "./ProfileVisibilitySection.vue?vue&type=script&lang=js&"
import style0 from "./ProfileVisibilitySection.vue?vue&type=style&index=0&id=05790d6a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05790d6a",
  null
  
)

export default component.exports